import { render, staticRenderFns } from "./colsData.vue?vue&type=template&id=1dfdec6a&"
import script from "./colsData.vue?vue&type=script&lang=js&"
export * from "./colsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports